import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import GarantiDetay from '../../components/WarrantyDetail';
import { text } from '../../modules/languages/index';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { safeParseInt } from 'src/utils/Common';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { createTheme } from "@material-ui/core"
import trLocale from "date-fns/locale/tr";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
}));
const ArcelikSari = '#FF9800';
const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: ArcelikSari,
      dark: siyah,
      main: siyah,
      light: siyah
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Garanti({ className, FisNo, readonly, tasks, defectReducer, labourReducer, UserFault, materialReducer }) {
  const classes = useStyles();
  const locale = "tr";
  let GarantiTipiDeger = '';
  let garantiTarihiDeger = '';



  let GarantiData = readonly 
    ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : [])
    : (Array.isArray(loadBaslandiJob()) ? loadBaslandiJob() : []);

  if (!readonly && (!GarantiData || GarantiData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      GarantiData = loadBaslandiJob() || [];
    }
  }

  if (!Array.isArray(GarantiData) || GarantiData.length === 0 || !GarantiData[0]) {
    GarantiTipiDeger = '';
    garantiTarihiDeger = '';
  } else {
    GarantiTipiDeger = GarantiData[0]?.GARANTI_TIPI;
    garantiTarihiDeger = GarantiData[0]?.GARANTI_TARIHI;
  }

  const [GarantiTipi, setGarantiTipi] = React.useState(GarantiTipiDeger);
  const [garantiTarihi, setGarantiTarihi] = React.useState(garantiTarihiDeger);
  if (GarantiData.length === 0) {
    return null;
  }


  const GarantiTipihandleChange = (event) => {
    var index = event.target.selectedIndex;
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    
    let job = jobs[0];
    job = {
      ...job,
      GARANTI_TIPI: event.target.value,
      GARANTI_TIPI_TEXT: event.target[index].text,
    };
    saveBaslandiJob(job);
    
    const updatedJobs = loadBaslandiJob();
    if (!Array.isArray(updatedJobs) || updatedJobs.length === 0) return;
    
    job = updatedJobs[0];
    let hizmetler = [];
    let iscilikler = [];
    let malzemeler = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    if (Array.isArray(defectReducer?.selected)) {
      for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h]
      hizmetler.push({ HIZMET_KODU: hizmet });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data?.filter(d => d.LabourCode === labourArray[i])?.[0];
          if (iscilik) {
            iscilikler.push({
              ISCILIK_KODU: iscilik?.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik?.LabourCode,
              ACIKLAMA: iscilik?.LabourDesc,
              FIYAT: parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0),
              FIYAT_LISTESI_ID: parseInt(job?.GARANTI_TIPI) === 1 ? iscilik?.PriceListIdWithoutWarranty : iscilik?.PriceListId,
              FIYAT_KODU: safeParseInt(iscilik?.PriceId)
            });
            iscilik_toplam += parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0);
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data?.filter(d => d.MaterialCode === materialArray[m])?.[0];
          if (malzeme) {
            malzemeler.push({
              MALZEME_KODU: malzeme?.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme?.MaterialCode,
              ADET: materialReducer[malzeme?.MaterialCode],
              ACIKLAMA: malzeme?.MaterialDesc,
              FIYAT: malzeme?.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme?.PriceListId,
              FIYAT_KODU: safeParseInt(malzeme?.PriceId)
            })
            malzeme_toplam += materialReducer[malzeme?.MaterialCode] * malzeme?.PriceWithWat;
          }
        }
      }
    }
    }
    job = {
      ...job,
      HIZMETLER: hizmetler,
      ISCILIKLER: iscilikler,
      MALZEMELER: malzemeler,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam,
    }
    saveBaslandiJob(job);
    setGarantiTipi(event.target.value);
  };

  const MerkezdenGarantiAl = (MerkezGarantiData) => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    if (!Array.isArray(MerkezGarantiData) || MerkezGarantiData.length === 0) return;
    
    let job = jobs[0];
    job = {
      ...job,
      GARANTI_TARIHI: MerkezGarantiData[0]?.GARANTI_BASLANGIC,
      GARANTI_TIPI: MerkezGarantiData[0]?.GARANTI_TIPI,
      GARANTI_TIPI_TEXT: MerkezGarantiData[0]?.GARANTI_TIPI_TEXT,
    }
    saveBaslandiJob(job);
    setGarantiTarihi(MerkezGarantiData[0]?.GARANTI_BASLANGIC);
    setGarantiTipi(MerkezGarantiData[0]?.GARANTI_TIPI);

    let hizmetlerGaranti = [];
    let isciliklerGaranti = [];
    let malzemelerGaranti = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    if (Array.isArray(defectReducer?.selected)) {
      for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h]
      hizmetlerGaranti.push({ HIZMET_KODU: hizmet });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data?.filter(d => d.LabourCode === labourArray[i])?.[0];
          if (iscilik) {
            isciliklerGaranti.push({
              ISCILIK_KODU: iscilik?.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik?.LabourCode,
              ACIKLAMA: iscilik?.LabourDesc,
              FIYAT: parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0),
              FIYAT_LISTESI_ID: parseInt(job?.GARANTI_TIPI) === 1 ? iscilik?.PriceListIdWithoutWarranty : iscilik?.PriceListId,
              FIYAT_KODU: safeParseInt(iscilik?.PriceId)
            });
            iscilik_toplam += parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0);
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data?.filter(d => d.MaterialCode === materialArray[m])?.[0];
          if (malzeme) {
            malzemelerGaranti.push({
              MALZEME_KODU: malzeme?.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme?.MaterialCode,
              ADET: materialReducer[malzeme?.MaterialCode],
              ACIKLAMA: malzeme?.MaterialDesc,
              FIYAT: malzeme?.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme?.PriceListId,
              FIYAT_KODU: safeParseInt(malzeme?.PriceId)
            })
            malzeme_toplam += materialReducer[malzeme?.MaterialCode] * malzeme?.PriceWithWat;
          }
        }
      }
    }
    }
    job = {
      ...job,
      HIZMETLER: hizmetlerGaranti,
      ISCILIKLER: isciliklerGaranti,
      MALZEMELER: malzemelerGaranti,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam,
    }





  }

  const GarantiTarihihandleChange = (value) => {

    var Deger = moment(value).format('YYYY-MM-DD');
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    
    let job = jobs[0];
    job = {
      ...job,
      GARANTI_TARIHI: Deger,
    }
    saveBaslandiJob(job);
    setGarantiTarihi(Deger);
  };
  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={text("Garanti_Detay")} />
      <Divider />
      <CardContent>
        <form
          className={clsx(classes.root, className)}>
          <div className={classes.fieldsGaranti}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  inputVariant="outlined"
                  InputProps={{
                    style: { borderRadius: "20px" }
                  }}
                  margin="normal"
                  color="primary"
                  id="GarantiTarihi"
                  label={text("Garanti_Tarihi")}
                  invalidDateMessage={'Hatalı Tarih Formatı'}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={garantiTarihi}
                  disabled={readonly}
                  onChange={e => GarantiTarihihandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </div>

          <div className={classes.fieldsGaranti}>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                fullWidth
                native
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={GarantiTipi}
                onChange={GarantiTipihandleChange}
                disabled={readonly}
              >
                <option aria-label="None" value="" />
                {UserFault ?
                  <>
                    <option value={3}>Memnuniyet Garantisi</option>
                  </> :

                  <>
                    <option value={1}>Garanti Dışı</option>
                    <option value={2}>Garanti İçi</option>
                    <option value={3}>Memnuniyet Garantisi</option>
                    <option value={4}>Parça Garantisi</option>
                    <option value={5}>Bayi Garantisi</option>
                    <option value={6}>Afet</option>
                    <option value={8}>Kiralık Ürün Garantisi</option>
                    <option value={9}>Ek Garanti</option>
                    <option value={10}>AEEE Garantisi</option>
                    <option value={13}>Arıtma Filtre Değişim Hakkı</option>
                    <option value={14}>Kalite</option>
                    <option value={15}>Sistem</option>
                    <option value={16}>MEB Etkileşimli Tahta</option>

                    <option value={17}>MEB Etkileşimli Tahta</option>
                    <option value={18}>Kampanyalı Parça Garantisi</option>
                    <option value={19}>Sigorta</option>

                  </>}

              </Select>
            </FormControl>
          </div>
        </form>
      </CardContent>
      <Divider />
      <CardContent>
        {window.navigator.onLine &&
          <GarantiDetay FisNo={FisNo} readonly={readonly}
            onClose={MerkezdenGarantiAl}></GarantiDetay>
        }
      </CardContent>
    </Card>
  );
}

Garanti.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
  })
)(Garanti);
